import { getApiUrl } from '../../util/api/api'

  const deleteDefaultlogo = async () => {
    const response = await fetch(
      getApiUrl('/dashboard/api/recruiter/company/logo'), {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      }
    )
    
    if (response?.ok) {
      const responseJson = await response.json()
      return Promise.resolve({ status: response.status, data: responseJson})
    }
    if (!response) return Promise.reject(null)

    const correlationId = response.headers?.get('x-correlation-id') || undefined
    return Promise.reject({
      status: response.status,
      data: response.statusText,
      ...(correlationId && { correlationId }),
    })
  }
  
  export default deleteDefaultlogo
